import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import lg from '../../images/location.webp'
import mob from '../../images/location-mob.webp'
import bg1 from '../../images/location-left-bg.webp'
import bg2 from '../../images/location-right-bg.webp'
import bg3 from '../../images/location-mob2.webp'
import bg4 from '../../images/location-mob1.webp'
import { FaMapMarkerAlt } from "react-icons/fa";

import { useMediaQuery } from 'react-responsive';
const Location = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 991px)' });

    return (
        <>

            <div id="location" className='location-section section-padding position-relative' >
                {!isMobile ?
                    <img src={bg1} alt="" className='img-fluid position-absolute' style={{ top: '-43px', left: '0' }}></img>
                    :
                    <img src={bg3} alt="" className='img-fluid position-absolute' style={{ top: '0', zIndex: '1', left: '0' }}></img>
                }
                <Container>
                    <Row>
                        <Col lg={7}>
                            <div className='location-content position-relative'>
                                {!isMobile?<h2 className='w-100'>Kollur is Ready to Move in now</h2>:<h2 className='lh-base'>Kollur is Ready to <br/>Move in now</h2>}
                                {!isMobile?<h6 className='mb-5 w-100'>Easy Access to IT Hubs, Schools, and Hospitals</h6>:<h6 className='mb-3 w-100'>Easy Access to IT Hubs, Schools, <br/>and Hospitals</h6>}
                                {/* <h6 className='mb-5'>Easy Access to IT Hubs, Schools, and Hospitals</h6> */}
                                <div className='row d-flex align-items-center mt-5'>
                                    <div className='col-lg-3 col-md-3 col-3 duration '>
                                        <div className='d-flex align-items-center duration-div'>
                                            <FaMapMarkerAlt size={isMobile ? 20 : 40} className='primary-color' />
                                            <div className="time-display">
                                                <p className="primary-color">05</p>
                                                <p className="primary-color">Mins</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-9 col-md-9 col-9 location'>
                                        <div>
                                            <p>from ORR Exit no. 2 , Nagulapalli, <br/>Edulnagulapally, Telangana</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='row d-flex align-items-center mt-4'>
                                    <div className='col-lg-3 col-md-3 col-3 duration '>
                                        <div className='d-flex align-items-center duration-div'>
                                            <FaMapMarkerAlt size={isMobile ? 20 : 40} className='primary-color' />
                                            <div className="time-display">
                                                <p className="primary-color">08</p>
                                                <p className="primary-color">Mins</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-9 location'>
                                        <div>
                                            <p>from many popular schools & <br/>educational institutions around Kollur</p>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className='row d-flex align-items-center mt-4'>
                                    <div className='col-lg-3 col-md-3 col-3 duration '>
                                        <div className='d-flex align-items-center duration-div'>
                                            <FaMapMarkerAlt size={isMobile ? 20 : 40} className='primary-color' />
                                            <div className="time-display">
                                                <p className="primary-color">10</p>
                                                <p className="primary-color">Mins</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-9 location'>
                                        <div>
                                            <p>From Neopolis (Kokapet SEZ) And The<br/>Major Commercial Hubs</p>
                                        </div>
                                    </div>
                                </div> */}
                                <div className='row d-flex align-items-center mt-4'>
                                    <div className='col-lg-3 col-md-3 col-3 duration '>
                                        <div className='d-flex align-items-center duration-div'>
                                            <FaMapMarkerAlt size={isMobile ? 20 : 40} className='primary-color' />
                                            <div className="time-display">
                                                <p className="primary-color">15</p>
                                                <p className="primary-color">Mins</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-9 location'>
                                        <div>
                                            <p>From Neopolis (Kokapet SEZ) And The<br/>Major Commercial Hubs</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='row d-flex align-items-center mt-4'>
                                    <div className='col-lg-3 col-md-3 col-3 duration '>
                                        <div className='d-flex align-items-center duration-div'>
                                            <FaMapMarkerAlt size={isMobile ? 20 : 40} className='primary-color' />
                                            <div className="time-display">
                                                <p className="primary-color">20</p>
                                                <p className="primary-color">Mins</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-9 location'>
                                        <div>
                                            <p>from Financial District, home to top <br/>multinational corporations</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='row d-flex align-items-center mt-4'>
                                    <div className='col-lg-3 col-md-3 col-3 duration '>
                                        <div className='d-flex align-items-center duration-div'>
                                            <FaMapMarkerAlt size={isMobile ? 20 : 40} className='primary-color' />
                                            <div className="time-display">
                                                <p className="primary-color">25</p>
                                                <p className="primary-color">Mins</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-9 location'>
                                        <div>
                                            <p>from top employment hotspots in and <br/>around Hyderabad</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={5}>
                            {!isMobile &&
                                <img src="/location.png" className='img-fluid w-100 position-relative' alt="" style={{ zIndex: '10', borderRadius: '15px' }}></img>
                            }
                        </Col>
                    </Row>
                </Container>
                
                {!isMobile ?
                    <img src={bg2} alt="" className='img-fluid position-absolute' style={{ right: '0', bottom: '0', zIndex: '1' }}></img>
                    :
                    <img src={bg4} alt="" className='img-fluid position-absolute' style={{ right: '0', bottom: '0' }}></img>
                }






            </div>
            {isMobile &&
            <img src="/locationmobile.png" className='img-fluid w-100 position-relative' alt="" style={{ zIndex: '10' }}></img>
            }
        </>
    )
}

export default Location
